import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  fetchAllemployeeReport,
  fetchAllemployeeNumberBymonth,
} from "../../../core/data/redux/reports/employee_report/employeereport.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { fetchAllDesignations } from "../../../core/data/redux/designation/designationAction";
import { fetchEmployeeAnalytics } from "../../../core/data/redux/employee/employeeAction";
import { exportToCSV, exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";

interface EmployeeReportProps {
  status?: "active" | "inactive";
  department?: string;
  project?: string;
  showOnlyTable?: boolean;
}

const EmployeeReports: React.FC<EmployeeReportProps> = ({ status, department, project , showOnlyTable}) => {
  const { EmployeeAnalytics } = useSelector((state: any) => state.employee);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [monthcount, setMonthcount] = useState<any[] | null>(null);
  const [employeereportDetail, setemployeereportDetail] = useState<any>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(status || "active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [
    dispatch,
    employeereportDetail,
    selectedStatus,
    selectedSort,
    filteredEmployees,
  ]);

  useEffect(() => {
    dispatch(fetchAllemployeeNumberBymonth(selectedYear)).then((res) => {
      const data = res.payload.data;
      setMonthcount(data);
    });
    dispatch(fetchEmployeeAnalytics());
    dispatch(fetchAllDesignations());
    dispatch(fetchAllemployeeReport()).then((res) => {
      setemployeereportDetail(res.payload.data);
      setFilteredEmployees(res.payload.data);
    });
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = employeereportDetail ? employeereportDetail : [];

  function filterEmployeeData(data: any[]) {
    return data.map(emp => ({
      EmpID: emp.EmpID || "N/A",
      Name: emp.Name || "N/A",
      Email: emp.Email || "N/A",
      Department: emp.Department || "N/A",
      Phone: emp.Phone || "N/A",
      JoiningDate: emp.JoiningDate || "N/A",
      Status: emp.Status || "N/A"
    }));
  }

  const data2 = filterEmployeeData(data)

  const filteredData = useMemo(() => {
    return filterData(
      data || [],
      { Status: selectedStatus },
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  const columns = [
    {
      title: "Emp ID",
      dataIndex: "EmpID",
      render: (text: string, record: any) => (
        <Link to={all_routes.employeedetails}>{record.EmpID}</Link>
      ),
      sorter: (a: any, b: any) => a.EmpID.length - b.EmpID.length,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <span key={record?.id} className="avatar avatar-rounded">
            <img
              className="border border-white"
              src={record?.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
              alt="img"
            />
          </span>
          <div className="ms-2">
            <p className="text-dark mb-0 fw-medium">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#view_details"
              >
                {record.Name}
              </Link>
            </p>
            <span className="fs-12 text-muted">{record.Role || ""}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => (a.Email || "").localeCompare(b.Email || ""),
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a: any, b: any) => (a.Department || "").localeCompare(b.Department || ""),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: any, b: any) => (a.Phone || "").localeCompare(b.Phone || ""),
    },
    {
      title: "Joining Date",
      dataIndex: "JoiningDate",
      sorter: (a: any, b: any) => a.JoiningDate.localeCompare(b.JoiningDate),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span
          className={`badge d-inline-flex align-items-center badge-xs ${text === "active" ? "badge-success" : "badge-danger"
            }`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.localeCompare(b.Status),
    },
  ];


  useEffect(() => {
    if (monthcount && monthcount.length > 0) {
      const monthlyCounts = new Array(12).fill(0);

      monthcount.forEach(({ month, employee_count }) => {
        const index = month - 1;
        if (index >= 0 && index < 12) {
          monthlyCounts[index] = employee_count;
        }
      });

      setEmployeechart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: monthlyCounts,
          },
        ],
      }));
    } else {
      setEmployeechart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: new Array(12).fill(0),
          },
        ],
      }));
    }
  }, [monthcount]);

  const [employeechart, setEmployeechart] = useState<any>({
    series: [
      {
        name: "New Employees",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "bar",
      height: 180,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    colors: ["#03C95A", "#E8E9EA"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: function (val: string) {
          return val + " Employee";
        },
      },
    },
  });

  useEffect(() => {
    const handleYearSelect = (year: any) => {
      setSelectedYear(year);
      dispatch(fetchAllemployeeNumberBymonth(year)).then((res) => {
        const data = res.payload.data;
        setMonthcount(data);
      });
    };
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllemployeeNumberBymonth(selectedYear)).then((res) => {
        const data = res.payload.data;
        setMonthcount(data);
      });
    }
  }, [selectedYear]);
if (showOnlyTable) {
  return (
   <Table
      key={tableKey}
      dataSource={filteredData}
      columns={columns}
      Selection={true}
    />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Employee_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Employee_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-icon.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Total Employee
                          </p>
                          <h5>{EmployeeAnalytics?.total_employees}</h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-success.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Active Employee
                          </p>
                          <h5>{EmployeeAnalytics?.active_employees}</h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-info.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            New Employee
                          </p>
                          <h5>{EmployeeAnalytics?.new_joinees}</h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-danger.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Inactive Employee
                          </p>
                          <h5>{EmployeeAnalytics?.inactive_employees}</h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center row-gap-2">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-bar text-danger" />
                      </span>
                      <h5>Employee </h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center me-3 mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Employees Joined
                      </p>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="employee-reports"
                    options={employeechart}
                    series={employeechart.series}
                    type="bar"
                    height={180}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employees List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3"></div>

               
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default EmployeeReports;
